import React from "react";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import "./notificationToast.css";

export const Toast = ({ type, message, duration }) => {
  toast[type](<CustomToast type={type} message={message} />, {
    autoClose: typeof duration === "number" ? duration : 3000,
    hideProgressBar: false,
    pauseOnHover: true,
    draggable: false,
  });
};

export const CustomToast = ({ type, message }) => {
  if (React.isValidElement(message)) {
    return <div>{message}</div>;
  }

  return (
    <div >
      <span style={{fontWeight:"bold", color:"#5c5b5b" }}>{message}</span>
    </div>
  );
};

Toast.propTypes = {
  type: PropTypes.string.isRequired,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  duration: PropTypes.number,
};

CustomToast.propTypes = {
  type: PropTypes.string.isRequired,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
};
